import React, { Component } from 'react';
import axios from 'axios';
import WalletOptions from './WalletOptions';

const BASE_URL = "https://my-json-server.typicode.com/themeland/netstorm-json-1/wallet";

class Activity extends Component {
    state = {
        data: {},
        walletData: []
    }
    componentDidMount() {
        axios.get(`${BASE_URL}`)
            .then(res => {
                this.setState({
                    data: res.data,
                    walletData: res.data.walletData
                })
                // console.log(this.state.data)
            })
            .catch(err => console.log(err))
    }
    render() {
        return (
            <section className="wallet-connect-area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-7">
                            {/* Intro */}
                            <div className="intro text-center">
                                <span>Wallet Connect</span>
                                <h3 className="mt-3 mb-0">Connect your wallet</h3>
                                <p>Connect your Elrond wallet to proceed:</p>
                            </div>
                        </div>
                    </div>
                    <WalletOptions />
                </div>
            </section>
        );
    }
}

export default Activity;